import React, { useState } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Page, Header } from 'components';
import { Card, CardHeader, CardContent, CardActions, Divider, TextField, Grid, Button, colors } from '@mui/material';

import { GetServiceIpAssignment, AddCell } from '../../actions/ServiceIpAssignmentActions.js';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3)
	},
	tabs: {
		marginTop: theme.spacing(3)
	},
	content: {
		marginTop: theme.spacing(3)
	},
	paper: {
		padding: theme.spacing(1)
	},
	popover: {
		pointerEvents: 'none'
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900]
		}
	}
}));

const ServiceIpAssignment = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const [cellList, setCells] = useState();
	const [cellId, setCellId] = useState();
	const [region, setRegion] = useState();
	const [vendor, setVendor] = useState();

	const user = useSelector(state => state.session.user);

	const _handleCellsChange = event => {
		setCells(event.target.value);
	};

	const _handleCellIdChange = event => {
		setCellId(event.target.value);
	};

	const _handleRegionChange = event => {
		setRegion(event.target.value);
	};

	const _handleVendorChange = event => {
		setVendor(event.target.value);
	};

	const _getRServiceIpAssignment = () => {
		const username = `${user.firstname} ${user.lastname}`;
		dispatch(GetServiceIpAssignment(cellList, username, user.id));
	};

	const _addCell = () => {
		dispatch(AddCell(cellId, region, vendor, user.id));
	};

	return (
		<Page className={classes.root} title="IP Assignment">
			<Header module="IpAssignment" view="Service IP Assignment" />
			<div className={clsx(classes.container)}>
				<Card className={classes.container}>
					<CardHeader title="IP Assignment" />
					<Divider />
					<CardContent>
						<Grid container spacing={2}>
							<Grid item md={9} xs={9}>
								<TextField
									fullWidth
									label="Cells"
									helperText="Example: Cell1,Cell2,Cell3"
									name="cells"
									onChange={_handleCellsChange}
									value={cellList}
									variant="outlined"
								/>
							</Grid>
							<Grid item md={3} xs={3}>
								<Button
									color="primary"
									variant="contained"
									size="large"
									onClick={_getRServiceIpAssignment}
								>
									Run Assignment
								</Button>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</div>
			<div className={clsx(classes.container)}>
				<Card className={classes.container}>
					<CardHeader title="Add New Cell" />
					<Divider />
					<CardContent>
						<Grid container spacing={2}>
							<Grid item md={3} xs={3}>
								<TextField
									fullWidth
									label="CellId"
									helperText="Example: 123456"
									name="CellId"
									onChange={_handleCellIdChange}
									value={cellId}
									variant="outlined"
								/>
							</Grid>
							<Grid item md={3} xs={3}>
								<TextField
									fullWidth
									label="Region"
									helperText="Example: Belfast"
									name="Region"
									onChange={_handleRegionChange}
									value={region}
									variant="outlined"
								/>
							</Grid>
							<Grid item md={3} xs={3}>
								<TextField
									fullWidth
									label="Vendor"
									helperText="Example: Huawei"
									name="Vendor"
									onChange={_handleVendorChange}
									value={vendor}
									variant="outlined"
								/>
							</Grid>
							<Grid item md={3} xs={3}>
								<Button
									color="primary"
									variant="contained"
									size="medium"
									onClick={_addCell}
								>
									Add Cell
								</Button>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</div>
		</Page>
	);
};

export default ServiceIpAssignment;
